import routineReducerFactory from './routineReducerFactory';
import { fetchAllTagData } from '../actions/routines';

const tagsInfo = routineReducerFactory(fetchAllTagData, { data: [] });

export default tagsInfo;
